(function () {
  'use strict';

  function initCardSliders(root) {
    root.querySelectorAll('[data-pc-slider]').forEach(function (slider) {
      if (slider.dataset.pcInit === 'true') return;
      slider.dataset.pcInit = 'true';

      var slidesWrap = slider.querySelector('[data-pc-slides]');
      var slides = slider.querySelectorAll('[data-pc-slide]');
      var dots = slider.querySelectorAll('[data-pc-dot]');

      function goTo(index) {
        if (!slidesWrap || !slides.length) return;
        index = Math.max(0, Math.min(index, slides.length - 1));
        slidesWrap.style.transform = 'translateX(-' + (index * 100) + '%)';
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === index);
        });
        slider.dataset.pcCurrent = index;
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          goTo(parseInt(dot.dataset.index, 10) || 0);
        });
      });

      // ---- swipe support: touch (mobile) + pointer drag (mouse/trackpad) ----
      var startX = null;
      var dragging = false;

      slider.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
      }, { passive: true });

      slider.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var diff = e.changedTouches[0].clientX - startX;
        var current = parseInt(slider.dataset.pcCurrent || '0', 10);
        if (Math.abs(diff) > 40) {
          goTo(diff < 0 ? current + 1 : current - 1);
        }
        startX = null;
      }, { passive: true });

      slider.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return; // handled above
        dragging = true;
        startX = e.clientX;
        // Keep receiving pointer events even if the cursor leaves the
        // slider mid-drag, so pointerup still fires reliably.
        if (slider.setPointerCapture) {
          slider.setPointerCapture(e.pointerId);
        }
        // Stop the browser's native "drag the image out" behavior from
        // hijacking the gesture when the pointer starts over an <img>.
        e.preventDefault();
      });

      slider.addEventListener('pointerup', function (e) {
        if (!dragging) return;
        dragging = false;
        var diff = e.clientX - startX;
        var current = parseInt(slider.dataset.pcCurrent || '0', 10);
        if (Math.abs(diff) > 40) {
          goTo(diff < 0 ? current + 1 : current - 1);
        }
        startX = null;
        if (slider.hasPointerCapture && slider.hasPointerCapture(e.pointerId)) {
          slider.releasePointerCapture(e.pointerId);
        }
      });

      slider.addEventListener('pointercancel', function () {
        dragging = false;
        startX = null;
      });

      slider.addEventListener('pointerleave', function () {
        // With pointer capture in place this is mostly a no-op safety net;
        // kept in case a browser doesn't support setPointerCapture.
        if (!slider.setPointerCapture) {
          dragging = false;
          startX = null;
        }
      });

      goTo(0);
    });
  }

  function initSwatches(root) {
    root.querySelectorAll('[data-pc-swatches]').forEach(function (fieldset) {
      if (fieldset.dataset.pcInit === 'true') return;
      fieldset.dataset.pcInit = 'true';

      fieldset.addEventListener('click', function (e) {
        var target = e.target.closest('label, input, button, [class*="swatch"]');
        if (!target) return;

        var container = target.tagName === 'LABEL' ? target : target.closest('label') || fieldset;
        var img = container.querySelector ? container.querySelector('img') : null;
        if (!img && target.tagName === 'IMG') img = target;
        if (!img) return;

        var card = fieldset.closest('.pc-card');
        if (!card) return;
        var mainImg = card.querySelector('.pc-slide img');
        var newSrc = img.currentSrc || img.src;
        if (mainImg && newSrc) mainImg.src = newSrc;
      });
    });
  }

  function initOuterCarousel(section) {
    if (!section || section.dataset.pcOuterInit === 'true') return;
    section.dataset.pcOuterInit = 'true';

    var track = section.querySelector('.pc-track');
    var prev = section.querySelector('.pc-nav-prev');
    var next = section.querySelector('.pc-nav-next');
    var pagination = section.querySelector('.pc-pagination');
    if (!track) return;

    function cardWidth() {
      var card = track.querySelector('.pc-card');
      if (!card) return track.clientWidth;
      var style = window.getComputedStyle(track);
      var gap = parseFloat(style.columnGap || style.gap || 20);
      return card.getBoundingClientRect().width + gap;
    }

    function scrollByCards(n) {
      track.scrollBy({ left: n * cardWidth(), behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByCards(-1); });
    if (next) next.addEventListener('click', function () { scrollByCards(1); });

    function updateNavState() {
      if (!prev || !next) return;
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }

    function buildPagination() {
      if (!pagination) return;
      var cards = track.querySelectorAll('.pc-card');
      var cw = cardWidth();
      // Bail out if layout isn't ready yet (0 width) instead of building
      // pagination off bad measurements — retried by the load/resize/
      // ResizeObserver hooks below.
      if (!cw || !track.clientWidth) return;
      var visible = Math.max(1, Math.round(track.clientWidth / cw));
      var pages = Math.max(1, Math.ceil(cards.length / visible));
      pagination.innerHTML = '';
      if (pages <= 1) return;
      for (var i = 0; i < pages; i++) {
        var b = document.createElement('button');
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        if (i === 0) b.classList.add('is-active');
        b.addEventListener('click', (function (page) {
          return function () {
            track.scrollTo({ left: page * visible * cw, behavior: 'smooth' });
          };
        })(i));
        pagination.appendChild(b);
      }
    }

    function syncPagination() {
      if (!pagination) return;
      var dots = pagination.querySelectorAll('button');
      if (!dots.length) return;
      var cw = cardWidth();
      if (!cw) return;
      var visible = Math.max(1, Math.round(track.clientWidth / cw));
      var page = Math.round(track.scrollLeft / (visible * cw));
      dots.forEach(function (d, i) {
        var active = i === page;
        d.classList.toggle('is-active', active);
        d.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(function () {
        updateNavState();
        syncPagination();
      });
    });

    // Debounce resize so we don't rebuild mid-transition (causes flicker).
    var resizeTimer;
    function scheduleRebuild() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        buildPagination();
        updateNavState();
      }, 150);
    }

    window.addEventListener('resize', scheduleRebuild);

    // Recalculate once every image inside the track has finished loading.
    // This is the fix for pagination "sometimes showing, sometimes not":
    // card width depends on image size, so building before images load
    // can measure the wrong width.
    var imgs = track.querySelectorAll('img');
    var pending = 0;
    imgs.forEach(function (img) {
      if (img.complete) return;
      pending++;
      img.addEventListener('load', settle, { once: true });
      img.addEventListener('error', settle, { once: true });
    });
    function settle() {
      pending--;
      if (pending <= 0) {
        buildPagination();
        updateNavState();
      }
    }

    // Catches width changes a window resize won't fire for: tab reveals,
    // modal opens, container-driven resizes, etc.
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(scheduleRebuild);
      ro.observe(track);
    }

    buildPagination();
    updateNavState();
  }

  function initSection(section) {
    if (!section) return;
    initCardSliders(section);
    initSwatches(section);
    initOuterCarousel(section);
  }

  function initAll(root) {
    (root || document).querySelectorAll('.pc-section').forEach(initSection);
  }

  window.PCCarousel = {
    init: function (sectionId) {
      var section = document.getElementById('pc-section-' + sectionId);
      initSection(section);
    },
    initAll: initAll
  };

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  // Re-init automatically whenever new carousel markup is injected into the
  // page (Prestige re-renders sections via AJAX on filtering, cart updates,
  // quick view, etc. without a full page reload, which would otherwise leave
  // dots/swatches without their click handlers).
  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.classList && node.classList.contains('pc-section')) {
            initSection(node);
          } else if (node.querySelectorAll) {
            node.querySelectorAll('.pc-section').forEach(initSection);
          }
        });
      });
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();